import { de } from "./de";

export const en: typeof de = {
  title: "Calculate reach and height of the extinguishing agent",
  text: "Please select a monitor and nozzle type shown in the following animation. After setting your operating conditions the reach and height of the extinguishing agent jet as well as the emerging reaction force are calculated. The result can be exported as PDF.",
  components: {
    addButton: {
      defaultAriaLabel: "Add",
    },
    languageSwitcher: {
      english: "English",
      german: "German",
      french: "French",
      imp: "Imperial",
      met: "Metric",
    },
    obstacleFormInput: {
      depth: "Depth",
      distance: "Distance",
      height: "Height",
    },
    resultsTextualSummary: {
      range: "Reach",
      throwingHeight: "Throw Height",
      distanceOfHeighestPoint: "Distance of Highest Point",
      recoil: "Reaction Force",
      footprintDiameter: "Footprint Diameter",
    },
    settings: {
      title: "Settings",
      headlineAngle: "Angle",
      headlineExtinguishingAgentFlow: "Extinguishing Agent Flow Rate",
      headlineGroundObstacle: "Ground Obstacle",
      headlineMedium: "Medium",
      headlineMonitorHeight: "Monitor Height",
      headlinePressure: "Pressure (at the inlet flange)",
      headlineRoofObstacle: "Roof Obstacle",
      obstacleLabel: "Obstacle",
      obstacleLabelWithNumber: "Obstacle {{obstacleNumber}}",
      nozzleOption: "NOZZLE: {{nozzleName}}",
      mediumFoam: "Foam",
      mediumWater: "Water",
      monitorOption: "MONITOR: {{monitorName}}",
    },
    removeButton: {
      defaultAriaLabel: "Remove",
    },
    results: {
      title: "Result",
      footerText:
        "The reach is measured from the point of discharge at the monitor to the centre of the impact area in almost still air.",
      buttonInfo: "Explanation",
      buttonPdf: "Export PDF ",
    },
    chart: {
      rangeInMeters: "Reach in Meter",
      heightInMeters: "Height in Meter",
      rangeInFoot: "Reach in Foot",
      heightInFoot: "Height in Foot",
    },
    pdfExport: {
      createdAt: "Created on {{dd}}.{{mm}}.{{yyyy}}",
      footerLinkLabel: "www.firedos.com",
    },
  },
  formatting: {
    numberWithoutDecimalPoints: "{{number, number(maximumFractionDigits: 0)}}",
    numberMaxOneDecimalPoint: "{{number, number(maximumFractionDigits: 1)}}",
    numberMaxTwoDecimalPoints: "{{number, number(maximumFractionDigits: 2)}}",
    numberMaxFourDecimalPoints: "{{number, number(maximumFractionDigits: 4)}}",
  },
  units: {
    bar: "bar",
    kiloNewton: "kN",
    literPerMinute: "l/min",
    meter: "m",
    foot: "ft",
    gallonPerMinute: "gal/min",
    psi: "psi",
  },
};
